import * as React from "react";

function SvgSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 512 512" {...props}>
      <path d="M0 209.94C0 325.7 94.18 419.88 209.94 419.88c50.7 0 97.25-18.06 133.57-48.09L483.72 512 512 483.72l-140.21-140.2c30.03-36.32 48.09-82.88 48.09-133.57C419.88 94.18 325.7 0 209.94 0S0 94.18 0 209.94zm39.99 0c0-93.71 76.24-169.95 169.95-169.95s169.95 76.24 169.95 169.95-76.24 169.95-169.95 169.95S39.99 303.65 39.99 209.94z" />
    </svg>
  );
}

export default SvgSearch;
